import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Box, Label, SpinnerLoader } from 'shared/ui'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { CombinedPriceInfo } from 'entities/Billing'
import { SendFromMulti } from 'widgets/SendFromMulti'
import { type AssignMemberToInboxStore } from 'pages/settings/pages/members/ui/AssignMemberToInbox/store/assignMemberToInboxStore'
import { AssignMemberActions } from 'pages/settings/pages/members/ui/AssignMemberToInbox/ui/AssignMemberActions/AssignMemberActions'
import styles from './styles.module.scss'

type IAssignMemberToExistingInboxProps = {
  store: AssignMemberToInboxStore
}

export const AssignMemberToExistingInbox = observer(
  ({ store }: IAssignMemberToExistingInboxProps) => {
    const { assignToExistingInboxStore, onCancel, isSeatRequired } = store
    const {
      sendFromMultiStore,
      canAssign,
      loading,
      combinedPriceInfoStore,
      isLoadingSeatPrice,
      loadSeatPriceData,
      handleAssign,
    } = assignToExistingInboxStore

    useEffect(() => {
      if (isSeatRequired) {
        loadSeatPriceData()
      }
    }, [isSeatRequired])

    const handleAction = async () => {
      const isSuccess = await handleAssign()
      if (isSuccess) {
        onCancel()
      }
    }

    return (
      <Box marginTop='32px' display='flex' flexDirection='column' gap='32px'>
        <div>
          <Label
            label={{
              text: 'Inbox',
            }}
            marginBottom='4px'
          />
          <SendFromMulti
            store={sendFromMultiStore}
            width={492}
            triggerProps={{
              emptyPlaceholder: 'Select',
              selectedOptionsCount: 2,
              isShowIcon: false,
              shouldShowSelectedItems: false,
              showNumbersCount: false,
              hideNumbers: true,
              triggerInnerContentClassName: styles.selectedItem,
            }}
            rightActions={[makeTextFieldIcon({ icon: 'chevronDown' })]}
            textFieldPlaceholderProps={{
              className: styles.inboxPlaceholderWrap,
              variant: 'stroke',
              size: 'medium',
            }}
            dropdownProps={{
              placeholder: 'Search',
              propsDropdownList: {
                autoHeightMax: 260,
              },
            }}
            dropdownGroupProps={{
              showSelectAllButton: false,
              stylesWrap: {
                padding: '4px 4px 8px',
              },
            }}
            popperProps={{
              offset: [0, -42],
            }}
          />
        </div>
        {isSeatRequired && (
          <div className={styles.seatPriceSection}>
            {isLoadingSeatPrice ? (
              <SpinnerLoader ariaLabel='Loading seat price' />
            ) : (
              <CombinedPriceInfo priceInfoStore={combinedPriceInfoStore} />
            )}
          </div>
        )}
        <div className={styles.actions}>
          <AssignMemberActions
            store={store}
            onAction={handleAction}
            disabled={!canAssign || (isSeatRequired && isLoadingSeatPrice)}
            loading={loading}
          />
        </div>
      </Box>
    )
  }
)
